import script from "./UrlUtils.vue?vue&type=script&lang=js"
export * from "./UrlUtils.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__